import { arenas, fighters } from './content'
import { useFightStore } from './store'

type Props = {
  onResume: () => void
  onRestart: () => void
  onSelectFighters: () => void
  runLabel?: string | null
}

export function FightPauseMenu({ onResume, onRestart, onSelectFighters, runLabel }: Props) {
  const playerIndex = useFightStore(s => s.playerIndex)
  const enemyIndex = useFightStore(s => s.enemyIndex)
  const arenaIndex = useFightStore(s => s.arenaIndex)
  const round = useFightStore(s => s.round)
  const playerWins = useFightStore(s => s.playerWins)
  const enemyWins = useFightStore(s => s.enemyWins)
  const mode = useFightStore(s => s.mode)
  const experienceMode = useFightStore(s => s.experienceMode)
  const player = fighters[playerIndex]
  const enemy = fighters[enemyIndex]
  const arena = arenas[arenaIndex]

  return (
    <section className="fight-pause" data-testid="fight-pause-menu" aria-label="Fight pause menu">
      <div className="fight-pause__veil" />
      <div className="fight-pause__panel">
        <header>
          <span>INYRON // COMBAT SUSPENDED</span>
          <h1>PAUSE MATRIX</h1>
          <p>The simulation is frozen. Fighter, round and arena state remain intact.</p>
        </header>
        <div className="fight-pause__matchup">
          <div><small>P1</small><strong>{player.name}</strong><span>{player.title}</span></div>
          <b>{playerWins} : {enemyWins}<em>ROUND {round}</em></b>
          <div className="right"><small>{mode === 'local' ? 'P2' : 'CPU'}</small><strong>{enemy.name}</strong><span>{enemy.title}</span></div>
        </div>
        <div className="fight-pause__telemetry">
          <span>ARENA <strong>{arena.name}</strong></span>
          <span>MODE <strong>{experienceMode.replaceAll('-', ' ').toUpperCase()}</strong></span>
          {runLabel && <span>RUN <strong>{runLabel}</strong></span>}
        </div>
        <div className="fight-pause__actions">
          <button type="button" className="primary" onClick={onResume}>RESUME FIGHT</button>
          <button type="button" onClick={onRestart}>RESTART MATCH</button>
          <button type="button" onClick={onSelectFighters}>{runLabel ? 'EXIT RUN / ROSTER' : 'SELECT FIGHTERS'}</button>
        </div>
        <footer>
          <span><kbd>ESC</kbd> / MENU resumes through the combat gate</span>
          <span>State-safe pause · no fighter or arena mutation</span>
        </footer>
      </div>
    </section>
  )
}
